import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-risk-review',
  templateUrl: './risk-review.component.html',
  styleUrls: ['./risk-review.component.scss']
})
export class RiskReviewComponent implements OnInit {
  groups: any[] = [];
  selected: any = null;
  events: any[] = [];
  search = '';
  filter = 'all';
  note = '';
  action = 'reviewing';
  target: any = null;
  canSuspend = false;
  loading = false;
  busy = false;
  error = '';
  message = '';
  company: string;
  private historyRequest = 0;
  constructor(private http: HttpService) { this.company = this.http.getStaticSelectedCompany(); }
  ngOnInit() { this.load(); }
  get visibleGroups() {
    const term = this.search.trim().toLowerCase();
    return this.groups.filter(g => (this.filter === 'all' || g.state === this.filter) &&
      (!term || g.players.some(p => [p.code,p.name,p.agent].some(v => String(v || '').toLowerCase().includes(term))) ||
      g.evidence.some(e => e.label.toLowerCase().includes(term))));
  }
  get hasDeviceEvidence() { return this.selected?.evidence.some(e => e.kind === 'device'); }
  evidencePlayers(evidence: any) {
    return (this.selected?.players || []).filter(p => evidence.player_ids.includes(Number(p.id)));
  }
  observation(evidence: any, player: any) {
    return (evidence.observations || []).find(o => Number(o.player_id) === Number(player.id));
  }
  get linkedCount() { return this.groups.reduce((sum, g) => sum + g.players.length, 0); }
  get pending() { return this.groups.reduce((sum, g) => sum + g.pending, 0); }
  async load() {
    this.loading = true; this.error = '';
    try {
      const result: any = await this.http.post('/admin/risk-review/list', {company_uuid:this.company});
      if (!result?.status) throw Error(result?.message || 'Unable to load risk reviews.');
      this.groups = result.groups; this.canSuspend = result.can_suspend;
      if (this.selected) {
        this.selected = this.groups.find(g => g.case_key === this.selected.case_key) || null;
        if (this.selected) await this.loadHistory();
      }
    } catch (e: any) { this.error = e.message; }
    finally { this.loading = false; }
  }
  async select(group: any) {
    if (this.busy) return;
    this.selected = group; this.note = ''; this.target = null; this.action = 'reviewing'; this.message = '';
    await this.loadHistory();
  }
  async loadHistory() {
    const request = ++this.historyRequest;
    this.events = [];
    const result: any = await this.http.post('/admin/risk-review/history', {company_uuid:this.company,case_key:this.selected.case_key});
    if (request !== this.historyRequest) return;
    if (result?.status) this.events = result.events;
    else this.error = result?.message || 'Unable to load review history.';
  }
  chooseAccount(player: any) {
    if (this.busy || !this.canSuspend) return;
    this.target = player;
    this.action = player.is_suspended == 1 ? 'restore' : 'suspend';
    this.note = ''; this.message = '';
  }
  async save() {
    if (this.busy || !this.selected || !this.note.trim()) return;
    if (['suspend','restore'].includes(this.action) && (!this.target || !this.canSuspend)) return;
    this.busy = true; this.error = ''; this.message = '';
    try {
      const result: any = await this.http.post('/admin/risk-review/decision', {
        company_uuid:this.company,case_key:this.selected.case_key,action:this.action,
        player_uuid:this.target?.uuid,note:this.note.trim()
      });
      if (!result?.status) throw Error(result?.message || 'Unable to save this decision.');
      this.message = result.message; this.note = ''; this.target = null; this.action = 'reviewing';
      await this.load();
    } catch (e: any) { this.error = e.message; }
    finally { this.busy = false; }
  }
}
